import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, ArrowRight, Shield, Phone } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import SEOHead from '../components/SEOHead';

export default function SuccessPage() {
  const { t, isRTL } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    // Only fire pixels if user actually submitted the form
    const wasSubmitted = sessionStorage.getItem('capitara_lead_submitted');
    if (!wasSubmitted) return;
    sessionStorage.removeItem('capitara_lead_submitted');

    // Get lead value from form (minimum $1000)
    const rawValue = parseInt(sessionStorage.getItem('capitara_lead_value') || '0', 10);
    const leadValue = Math.max(rawValue, 1000);
    sessionStorage.removeItem('capitara_lead_value');

    // Facebook Pixel 2 — Lead event with value
    if (typeof window.fbq === 'function') {
      window.fbq('trackSingle', '1934450234107970', 'Lead', {
        value: leadValue,
        currency: 'USD',
        content_name: 'Form Submission Success',
        content_category: 'Fund Recovery',
      });
    }

    // Google Ads — Conversion event with value
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17767732872',
        value: leadValue,
        currency: 'USD',
        event_category: 'Lead',
        event_label: 'Form Success Page',
      });
    }
  }, []);

  return (
    <div className="lead-form-page" dir={isRTL ? 'rtl' : 'ltr'} data-testid="success-page">
      <SEOHead page="success" />
      <div className="islamic-pattern"></div>

      <div className="success-page-content">
        <div className="success-icon-wrap">
          <CheckCircle size={80} color="#10B981" strokeWidth={1.5} />
        </div>

        <h1 className="success-title">{t.formSuccessTitle || 'Заявка отправлена!'}</h1>
        <p className="success-text">{t.formSuccessText || 'Наш менеджер свяжется с вами в ближайшее время'}</p>

        <div className="success-info-card">
          <div className="success-info-row">
            <Phone size={18} color="var(--brand-primary)" />
            <span>{t.successResponseTime || 'Среднее время ответа — 15 минут'}</span>
          </div>
          <div className="success-info-row">
            <Shield size={18} color="var(--brand-primary)" />
            <span>{t.successConfidential || 'Ваши данные защищены и конфиденциальны'}</span>
          </div>
        </div>

        <button className="btn-primary btn-large" onClick={() => navigate('/')} data-testid="back-to-site-btn">
          {t.formBackToSite || 'Вернуться на сайт'} <ArrowRight size={18} />
        </button>
      </div>
    </div>
  );
}
